import { StyledUnderline } from '@components/Underline/styled';
import styled from 'styled-components';

export const StyledTitle = styled.h6`
  font-size: calc(var(--title-size) * .7);
  font-weight: 900;
  color: var(--color-text);
  transition: color var(--theme-transition-duration);
  position: relative;
  z-index: 5;

  ${StyledUnderline} {
    font-weight: 900;
  }

  @media screen and (min-width: 1024px) {
    font-size: var(--title-size);
  }
`;